//@flow

const dataReducer = (state = {}, action) => {
  switch (action.type) {
    case "ADD_OBJECT":
      if (action.name in state) {
        if (action.id in state[action.name]) {
          return Object.assign({}, state, {
            [action.name]: {
              ...state[action.name],
              [action.id]: {
                ...state[action.name][action.id],
                props: action.object,
                ts: action.ts,
              },
            },
          })
        } else {
          return Object.assign({}, state, {
            [action.name]: {
              ...state[action.name],
              [action.id]: {
                props: action.object,
                ts: action.ts,
              },
            },
          })
        }
      } else {
        return Object.assign({}, state, {
          [action.name]: {
            [action.id]: {
              props: action.object,
              ts: action.ts,
            },
          },
        })
      }
    case "ADD_LIST":
      if (action.name in state) {
        return Object.assign({}, state, {
          [action.name]: {
            ...state[action.name],
            ...action.objectChunk,
          },
        })
      } else {
        return Object.assign({}, state, {
          [action.name]: {
            ...action.objectChunk,
          },
        })
      }
    case "UPDATE_PROP":
      return Object.assign({}, state, {
        [action.name]: {
          ...state[action.name],
          [action.id]: {
            ...state[action.name][action.id],
            props: {
              ...state[action.name][action.id].props,
              [action.propName]: action.value,
            },
            ts: action.ts,
          },
        },
      })

    case "ADD_PATH_ID":
      return Object.assign({}, state, {
        [`idFor${action.path}`]: action.id,
      })

    case "ADD_CHILDREN":
      if (action.parentName in state) {
        if (action.parentID in state[action.parentName]) {
          if ("children" in state[action.parentName][action.parentID]) {
            return Object.assign({}, state, {
              [action.parentName]: {
                ...state[action.parentName],
                [action.parentID]: {
                  ...state[action.parentName][action.parentID],
                  children: {
                    ...state[action.parentName][action.parentID].children,
                    [action.oName]: {
                      ids: action.ids.slice(),
                      ts: action.ts,
                    },
                  },
                },
              },
            })
          } else {
            return {
              ...state,
              [action.parentName]: {
                ...state[action.parentName],
                [action.parentID]: {
                  ...state[action.parentName][action.parentID],
                  children: {
                    [action.oName]: {
                      ids: action.ids.slice(),
                      ts: action.ts,
                    },
                  },
                },
              },
            }
          }
        } else {
          return Object.assign({}, state, {
            [action.parentName]: {
              ...state[action.parentName],
              [action.parentID]: {
                children: {
                  [action.oName]: {
                    ids: action.ids.slice(),
                    ts: action.ts,
                  },
                },
              },
            },
          })
        }
      } else {
        return Object.assign({}, state, {
          [action.parentName]: {
            [action.parentID]: {
              children: {
                [action.oName]: {
                  ids: action.ids.slice(),
                  ts: action.ts,
                },
              },
            },
          },
        })
      }
    case "REMOVE_OBJECT":
      if (action.name in state) {
        if (action.id in state[action.name]) {
          const deletedState = { ...state }
          delete deletedState[action.name][action.id]
          return deletedState
        }
      }
      return state
    case "REMOVE_CHILDREN":
      if (action.name in state) {
        if (action.id in state[action.name]) {
          if ("children" in state[action.name][action.id]) {
            if (action.childName in state[action.name][action.id].children) {
              const deletedChildren = { ...state }
              delete deletedChildren[action.name][action.id].children[
                action.childName
              ]
              return deletedChildren
            }
          }
        }
      }
      return state
    case "DROP_DATA":
      return {}
    default:
      return state
  }
}

export default dataReducer
